'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useAppPermissions = require('./useAppPermissions');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_useAppPermissions).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }